import * as React from 'react';
import {
  extendDataItem,
  mapTreeItem,
  TreeList,
  TreeListExpandChangeEvent
} from '@progress/kendo-react-treelist';

import { Component } from '../../dispatcher/modules';
import { Position, RequestDataBase } from '../../dispatcher/Types';
import _ from 'lodash';
import uuid from 'uuid-random';
import { TREE_GRID_PROPS, TREE_GRID_STATE_PROPS } from './TreeGridTypes';

export default class TreeGrid extends Component<TREE_GRID_PROPS, TREE_GRID_STATE_PROPS> {
  state:TREE_GRID_STATE_PROPS = {
    data: [],
    expanded: []
  };

  moduleId = uuid();

  loadData = (responseObject: any) => {
    const { items: data = [] } = responseObject || {};
    this.setState({
      data
    });
  };

  onRefreshData = (requestCfg?: RequestDataBase) => {
    const { url, params = {} } = requestCfg;
    const { mask, moduleId = this.moduleId, pieceByPieceLoad } = this.props;
    this.dispatch('treeGridLoadData', {
      persistent: ['params'],
      pos: Position.end
    }, {
      url,
      params,
      mask,
      moduleId,
      pieceByPieceLoad
    });
  };

  moduleDidMount() {
    const { refreshDataOnMount, requestCfg } = this.props;
    if (refreshDataOnMount) {
      this.refreshData(requestCfg);
    }
  }

  onExpandChange = (event: TreeListExpandChangeEvent) => {
    const expanded: boolean = !event.value;
    const tree: any[] = [...this.state.data];

    mapTreeItem(
      tree,
      event.level,
      'subItems',
      item => extendDataItem(item, 'subItems', { ['expanded']: expanded })
    );

    this.setState({
      data: tree,
      expanded: event.value ?
        this.state.expanded.filter(id => id !== event.dataItem.id) :
        [...this.state.expanded, event.dataItem.id]
    });
  }

  renderBody() {
    let { columns, rowHeight = 40, height = '100%', width = '100%', overflow = 'auto' } = this.props;
    if (_.isNumber(height)) {
      height = `${height}px`;
    }
    if (_.isNumber(width)) {
      width = `${width}px`;
    }
    return (
      <TreeList
        style={{ height: height, overflow: overflow, width: width }}
        tableProps={{
          style: {
            tableLayout: 'fixed',
            width: '100%'
          }
        }}
        rowHeight={rowHeight}
        scrollable="virtual"
        columnVirtualization={false}
        data={this.state.data}
        expandField={'expanded'}
        subItemsField={'subItems'}
        onExpandChange={this.onExpandChange}
        // TODO ooverridden kendo because it doesn't have a type that supports a custom cell(but working). Check after migration to newer kendo version
        // @ts-ignore
        columns={columns}
      />
    );
  }
}

